<template>
  <div id="home">
    <Banner :destinations="destinations"></Banner>
    <Searchbanner v-if="showBanner" @close="showBanner = false"></Searchbanner>
    <CoupsDeCoeurHome :user="this.user" @connection="openModal" :lodgings="cdc_lodgings" :wishlist="wishlist"></CoupsDeCoeurHome>
    <Propositions></Propositions>
    <ClubHortense />
    <lodgingCard :user="this.user" @connection="openModal" :lodgings="lodgings" :wishlist="wishlist" v-if="lodgings">
    </lodgingCard>
    <CollectionHome :collections="collections" v-if="collections"></CollectionHome>
    <ExperienceHomeNew />
    <AccommodationCard
      v-if="accommodations"
      :user="this.user"
      :lodgings="accommodations"
      :wishlist="wishlist"
      @connection="openModal"
      @collectionSelected="selectedCollection = $event"
    />
    <Destination :destinations="destinations" v-if="destinations"></Destination>
    <BecomeHost />
  </div>
</template>

<script>
import fetcher from "../packs/shared/api.js";
import Banner from "../components/shared/Banner.vue";
import Tips from "../components/Tips.vue";
import Propositions from "../components/Propositions.vue";
import ExperienceHortense from "../components/ExperienceHortense.vue";
import Weekend from "../components/Weekend.vue";
import Exclusive from "../components/Exclusive.vue";
import ExperienceHome from "../components/ExperienceHome.vue";
import GiftCardHome from "../components/GiftCardHome.vue";
import Destination from "../components/Destination.vue";
import CollectionHome from "../components/collection/CollectionHome.vue";
import ExperienceHomeNew from "../components/ExperienceHomeNew.vue";
import EvergreenHome from "../components/EvergreenHome.vue";
import LabelHome from "../components/LabelHome.vue";
import WhoIsHome from "../components/WhoIsHome.vue";
import FidHome from "../components/FidHome.vue";
import lodgingCard from "../components/cards/LodgingCard.vue";
import ScrollUp from "../components/btns/ScrollUp.vue";
import Reassurance from "../components/Reassurance.vue";
import Searchbtn from "../components/btns/Searchbtn.vue";
import Searchbanner from "../components/btns/Searchbanner.vue";
import AccommodationCard from "../components/cards/AccommodationCard.vue";
import SeasonsCard from "../components/cards/SeasonsCard.vue";
import BecomeHost from "../components/BecomeHost.vue";
import ClubHortense from "../components/ClubHortense.vue";
import CoupsDeCoeurHome from "../components/CoupsDeCoeurHome.vue";

export default {
  name: "home",
  props: ["user", "cdc_lodgings"],
  components: {
    Banner,
    Tips,
    Propositions,
    ExperienceHortense,
    lodgingCard,
    Weekend,
    Exclusive,
    ExperienceHome,
    GiftCardHome,
    Destination,
    CollectionHome,
    EvergreenHome,
    LabelHome,
    WhoIsHome,
    FidHome,
    ScrollUp,
    Searchbtn,
    Reassurance,
    Searchbanner,
    AccommodationCard,
    SeasonsCard,
    ExperienceHomeNew,
    BecomeHost,
    ClubHortense,
    CoupsDeCoeurHome
  },
  data() {
    return {
      showBanner: false,
      lodgings: null,
      weekends: null,
      exclusives: null,
      experiences: null,
      destinations: null,
      collections: null,
      wishlist: null,
      accommodations: null,
      selectedCollection: null,
      isLoading: true,
      fetchAbortController: null
    };
  },
  methods: {
    openModal() {
      this.$root.$emit("openModal");
    },
    redirectToTop() {
      //window.location.href = "/reservation-hotel?search="
      window.scrollTo(0, "#navbar");
    },
    async fetchHomeLoadings() {
      try {
        const responseAccommodation = await fetcher.get(
          "/home_lodgings", {
            params: { collection: this.selectedCollection }
          }
        );
        this.accommodations = responseAccommodation.data;
      } catch (e) {
        console.error('Error fetching home lodgings:', e);
      }
    },
    async fetchdatas() {
      try {
        this.isLoading = true;
        this.lodgings = [];
        
        // Parallelize all API requests for better performance
        const requests = [
          fetcher.get("/weekends/"),
          fetcher.get("/basic/experiences/"),
          fetcher.get("/destination", {
            params: { countries: ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE'] }
          }),
          fetcher.get("/collections/"),
          fetcher.get("/programme-evergreen-demarche-environnementale/"),
          this.user ? fetcher.get("/wishlists") : Promise.resolve({ data: null })
        ];

        const [
          responseWeekend,
          responseExperience,
          responseDestination,
          responseCollection,
          responseEvergreen,
          responseWishlist
        ] = await Promise.all(requests);

        // Assign data
        this.weekends = responseWeekend.data;
        this.experiences = responseExperience.data;
        this.destinations = responseDestination.data;
        this.collections = responseCollection.data;
        if (this.user && responseWishlist.data) {
          this.wishlist = responseWishlist.data;
        }

        // Fetch home lodgings after critical data is loaded
        await this.fetchHomeLoadings();
      } catch (e) {
        console.error('Error fetching home data:', e);
      } finally {
        this.isLoading = false;
      }
    }
  },
  beforeMount() {
    this.fetchdatas();
  },
  watch: {
    selectedCollection() {
      this.fetchHomeLoadings();
    }
  },
  beforeDestroy() {
    // Cancel any pending requests if component is destroyed
    if (this.fetchAbortController) {
      this.fetchAbortController.abort();
    }
  }
};
</script>
<style>
.container-index {
  margin-top: 3vh !important;
}

@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .container-index {
    margin-top: 22vh !important;
  }
}

#home {
  .experience {
    .modal-mask {
      top: 6%;
    }
  }
}
</style>
